import { groq } from '#imports';

export function getQuery({ slug, tags = [] } = {}) {
  if (tags.length > 0) {
    return groq`*[_type == "news" && !(_id in path('drafts.**')) && slug.current != "${slug}" && references(*[_type=="tag" && name in ${JSON.stringify(
      tags
    )}]._id)] | order(publishedAt desc) [0...30] {
      slug,
      title,
      publishedAt
    }`;
  }
  return groq`*[_type == "news" && !(_id in path('drafts.**')) && slug.current != "${slug}"] | order(publishedAt desc) [0...30] {
    slug,
    title,
    publishedAt
  }`;
}
